<template>
  <div class="dialog-wrap">
    <el-dialog
      title="推荐编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="推荐位置" prop="position_code">
          <el-select v-model="dataForm.position_code" placeholder="请选择推荐位置" style="width: 100%;" @change="handlePositionChange">
            <el-option
              v-for="item in positions"
              :key="item.id"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐内容" prop="ref_id">
          <el-input v-model="dataForm.ref_content.name" :disabled="!dataForm.ref_type" placeholder="请选择推荐内容" @focus="handleContentChoose"></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <ContentChoose
      :visible="contentChooseDialog"
      @close="contentChooseDialog = false"
      @submit="handleContentChooseSave"
      :ref_type ="dataForm.ref_type"
    ></ContentChoose>
  </div>
</template>

<script>
import ContentChoose from "@/components/dialog/ContentChoose";
import { recommendUpdate, recommendPositionList } from '@/api/recommend'

export default {
  components: {
    ContentChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      contentChooseDialog: false,
      dataForm: this.content || {
        position_code: '',
        ref_type: null,
        ref_id: null,
        ref_content: {}
      },
      types: [
        {label: '课程', value: 1},
        {label: '题库', value: 2},
        {label: '阅读资料', value: 3},
        {label: '实体资料', value: 4}
      ],
      positions: [],
      rules: {
        position_code: [{ required: true, message: '请选择推荐位置', trigger: 'change' }],
        ref_id: [{ required: true, message: '请选择推荐内容', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchPositionList()
      }
    },
    content (val) {
      this.dataForm = val
      this.dataForm.ref_content = this.dataForm.ref_content || {}
    }
  },
  methods: {
    fetchPositionList() {
      recommendPositionList({isPaging: 0}).then(res => {
        this.positions = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            position_code: this.dataForm.position_code,
            ref_id: this.dataForm.ref_id,
            ref_type: this.dataForm.ref_type,
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0,
          }
          recommendUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.handleResize()
      this.$emit('close')
    },
    handleResize() {
      this.dataForm.ref_type = null
      this.dataForm.ref_id = null
      this.dataForm.ref_content = {}
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handlePositionChange(value) {
      const position = this.positions.find(v => v.code == value)
      this.dataForm.ref_type = position.type
      this.dataForm.ref_id = null
      this.dataForm.ref_content = {}
    },
    handleContentChoose() {
      this.contentChooseDialog = true
    },
    handleContentChooseSave(value) {
      this.dataForm.ref_id = value.id
      this.dataForm.ref_content = value
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;

      .cover-uploader /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 100%;
      }
      .cover-uploader /deep/ .el-upload:hover {
        border-color: #409EFF;
      }
      .cover-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .cover {
        display: block;
        width: 100%;
        height: 100px;
        object-fit: cover;
      }
      .ref-box {
        /deep/ .el-input__inner {
          border-style: dashed;
        }
      }
    }
  }
</style>
